import { MomentModule } from 'ngx-moment';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContractDetailPage } from './contract-detail';

@NgModule({
  declarations: [
    ContractDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(ContractDetailPage),
    MomentModule
  ],
})
export class ContractDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contract-detail/contract-detail.module.ts